<script setup>
import { FullStory } from '@fullstory/browser'
import { RouterView } from 'vue-router'
import { computed, watch } from 'vue'
import { useAuthStore } from '@/store/auth'
import { useRoute } from 'vue-router'
import { useUtilsStore } from '@/store/utils'
import LoadingView from '@/views/LoadingView.vue'
import GlobalFooter from '@/components/GlobalFooter.vue'
import GlobalToolbar from '@/components/GlobalToolbar.vue'
import SiteFooter from '@/components/SiteFooter.vue'

const authStore = useAuthStore()
const utilsStore = useUtilsStore()
const route = useRoute()

const hideToolbar = computed(() => {
  return route.meta?.hideToolbar
})

const enableMarketingChangesFlag = computed(() => {
  return import.meta.env.VITE_ENABLE_MARKETING_CHANGES === 'true'
})

watch(
  () => authStore.isAuthenticated,
  () => {
    if (authStore.isAuthenticated) {
      FullStory('setIdentity', {
        uid: authStore.userId,
        properties: {
          email: authStore.email,
          displayName: authStore.getFullName() || '',
        },
      })
    }
  },
  {
    immediate: true,
  },
)
</script>

<template>
  <div :class="['app__container', { app__container__padding: !hideToolbar }]">
    <main class="app__main">
      <GlobalToolbar v-if="!hideToolbar" />

      <LoadingView style="width: 100%" v-if="utilsStore.isLoading" />
      <RouterView v-else />
    </main>

    <GlobalFooter v-if="!hideToolbar && !enableMarketingChangesFlag" class="app__footer" />
  </div>
  <SiteFooter v-if="!hideToolbar && enableMarketingChangesFlag" class="app__footer" />
</template>

<style scoped>
.app__container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app__container__padding {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.app__main {
  flex: 1;
}

.header-toolbar {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-toolbar__right-side {
  display: flex;
  align-items: center;
  gap: 24px;
}

.header-toolbar__login-btn {
  margin-right: 12px;
}

.app__footer {
  margin-top: 48px;
}

@media (max-width: 1280px) {
  .app__container__padding {
    margin-left: 40px;
    margin-right: 40px;
  }

  .header-toolbar__login-btn {
    display: none;
  }
}

@media (max-width: 768px) {
  .app__container__padding {
    margin-left: 20px;
    margin-right: 20px;
  }

  .header-toolbar__login-btn {
    display: none;
  }
}
</style>
